import React from "react";

import { useIntl } from "react-intl";

import Switch from "ds/Switch";

import * as S from "./ComparisonModeSwitch.styles";

export type ComparisonModeSwitchProps = {
  isComparisonMode: boolean;
  onChange: (newComparisonMode: boolean) => void;
};

const ComparisonModeSwitch = ({
  isComparisonMode,
  onChange
}: ComparisonModeSwitchProps) => {
  const intl = useIntl();

  return (
    <S.Layout>
      <Switch
        label={intl.formatMessage({
          id: "conprof.comparison_mode.switch"
        })}
        checked={isComparisonMode}
        onCheckedChange={onChange}
      />
    </S.Layout>
  );
};

export default ComparisonModeSwitch;
